import { render } from "./Appeals.vue?vue&type=template&id=63ec8de7"
import script from "./Appeals.vue?vue&type=script&lang=js"
export * from "./Appeals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/direct_mail/Appeals.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ec8de7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ec8de7', __exports__)) {
    api.reload('63ec8de7', __exports__)
  }
  
  module.hot.accept("./Appeals.vue?vue&type=template&id=63ec8de7", () => {
    api.rerender('63ec8de7', render)
  })

}


export default __exports__